var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThreeDotsVerticalGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3C2.825 3 3.5 2.325 3.5 1.5C3.5 0.675 2.825 0 2 0C1.175 0 0.5 0.675 0.5 1.5C0.5 2.325 1.175 3 2 3ZM2 4.5C1.175 4.5 0.5 5.175 0.5 6C0.5 6.825 1.175 7.5 2 7.5C2.825 7.5 3.5 6.825 3.5 6C3.5 5.175 2.825 4.5 2 4.5ZM2 9C1.175 9 0.5 9.675 0.5 10.5C0.5 11.325 1.175 12 2 12C2.825 12 3.5 11.325 3.5 10.5C3.5 9.675 2.825 9 2 9Z",
    fill: "#959595"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDotsVerticalGray);
export default __webpack_public_path__ + "static/media/icon_three_dots_vertical_gray.45d9ebbfb9df87f86b17744b9b295942.svg";
export { ForwardRef as ReactComponent };